import React from 'react';
import OdfjellPanel, { PANEL_CONSTANTS } from 'src/components/ui/odfjellPanel/OdfjellPanel';
import { useStowageStore } from 'src/context/StowageContext';

const StowageModalComponent: React.FC = () => {
    const { stowageModalData, setStowageModalData } = useStowageStore();

    const action = async () => {
        const result = stowageModalData.action();
        if (result instanceof Promise) {
            await result;
        }
        setStowageModalData(null);
    };

    const cancel = () => {
        stowageModalData.cancel();
        setStowageModalData(null);
    };

    if (!stowageModalData) return <></>;

    return (
        stowageModalData && (
            <OdfjellPanel
                headerTitle={stowageModalData.title}
                defaultPosition="center"
                preventOutsideClose={true}
                hasCurtain={true}
                panelWidth={PANEL_CONSTANTS.SMALL_WIDTH}
                onCancel={stowageModalData.cancel ? () => cancel() : null}
                onAction={stowageModalData.action ? () => action() : null}
                showCancelButton={stowageModalData.cancel ? true : false}
                actionButtonText={stowageModalData.actionButtonText}
            >
                {stowageModalData.message}
            </OdfjellPanel>
        )
    );
};

export default StowageModalComponent;
